








































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormProvider from '@shared/components/forms/form-provider.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Input from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Section from '@shared/components/forms/inputs/section/section.vue';
import { AccessPointFormModelInterface, AccessType } from '@access-control/interfaces/access-point';
import { accessPointFieldConfig } from '@access-control/config/access_point_options';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import ResourceAccessConfiguration from '@access-control/components/forms/access-point/resource-access-configuration.vue';

@Component({
  name: 'bc-access-point-form',
  components: {
    'bpc-entity-select': EntitySelect,
    'bpc-form-provider': FormProvider,
    'bc-input': Input,
    'bc-textarea': Textarea,
    'bc-section': Section,
    'bc-select': Select,
    'bc-switch': Switch,
    'bc-resource-access-configuration': ResourceAccessConfiguration,

    'bc-entity-select': EntitySelect,
  },
})
export default class AccessPointForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
  };

  // PROPS
  @Prop(Object) readonly initialData: Partial<AccessPointFormModelInterface>;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop(Number) readonly modelId: number;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: AccessPointFormModelInterface;

  // LIFECYCLE
  mounted() {
    this.getResources();
  }

  // DATA
  availableResources = [];
  resourceReady: boolean = false;

  // COMPUTED
  get formModel(): AccessPointFormModelInterface {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return accessPointFieldConfig;
  }

  // METHODS

  saveEntity() {
    this.$refs.formProvider.saveEntity(this.formModel);
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    const errorMsg = e?.response?.data?.message ? e.response.data.message : e.message;
    this.$bpcMessage.showErrorMessage({ text: errorMsg });
    this.$emit('entity-error-saving', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  prepareToSave(model: AccessPointFormModelInterface) {
    return model;
  }

  removeResourceAccessConfiguration(index: number) {
    this.formModel.resourceAccessConfigurations.splice(index, 1);
  }

  addConfiguration() {
    this.formModel.resourceAccessConfigurations.push({
      id: null,
      access_point_id: this.modelId,
      resource_id: null,
      access_type: AccessType.Entry,
    });
  }

  public getResources() {
    const params = {
      access_point_id: this.modelId,
    };
    const path = this.$bpcApiRouteHelper.getEntityPath('resources');
    this.resourceReady = false;
    this.$bpcApi
      .get(path, {
        params: params,
      })
      .subscribe(res => {
        this.availableResources = res.data;
        this.resourceReady = true;
      });
  }
}
